import { Capacitor } from '@capacitor/core'
import { useAuthenticateSAML } from '../store/useAuthenticateSAML'
import { computed } from 'vue'

export const useAPIURLs = () => {
  const { getJWT } = useAuthenticateSAML()
  const API_VERSION = '/api/v1'

  //routes
  const loginSaml = `${API_VERSION}/auth/login-saml`
  const logout = `${API_VERSION}/auth/logout`
  const samlRequest = `${API_VERSION}/auth/saml-request`
  const sync = `${API_VERSION}/sync/${
    getJWT && getJWT.staffing_users_id ? getJWT.staffing_users_id : ''
  }`
  const checkVersion = `${API_VERSION}/version_name`
  const getMessagingUsers = `${API_VERSION}/staffing_user/${
    getJWT && getJWT.staffing_users_id ? getJWT.staffing_users_id : ''
  }/message_users`
  const getAreaStaffingUsers = `${API_VERSION}/staffing_user/${
    getJWT && getJWT.staffing_users_id ? getJWT.staffing_users_id : ''
  }/area_staff`

  const domain = computed(() => {
    console.log(process.env.API_URL)
    if (Capacitor.isNativePlatform() && process.env.API_URL) {
      return process.env.API_URL
    } else if (Capacitor.isNativePlatform()) {
      return 'https://app.neptune-acceptance.networkninja.com'
    } else {
      return '' //can set your proxy in quasar.conf
    }
  })

  const returnAPIRoute = (route: string) => {
    return `${domain.value}${route}`
  }
  const API = computed(() => {
    return {
      loginSaml: returnAPIRoute(loginSaml),
      samlRequest: returnAPIRoute(samlRequest),
      sync: returnAPIRoute(sync),
      checkVersion: returnAPIRoute(checkVersion),
      getMessagingUsers: returnAPIRoute(getMessagingUsers),
      getAreaStaffingUsers: returnAPIRoute(getAreaStaffingUsers),
      logout: returnAPIRoute(logout),
    }
  })

  return {
    API,
  }
}
